<template>
  <div>
    <p class="success-text">
      Siga os próximos passos para cadastrar os seus pets na Área do Cliente:
    </p>

    <ul>
      <li>
        <p>
          <strong>1.</strong> Acesse a Área do Cliente no site
          <a href="https://valesaudepet.com.br/" target="_blank">
            valesaudepet.com.br
          </a>
          ou pelo App Meu Alelo.
        </p>
      </li>

      <li>
        <p><strong>2.</strong> Clique em Primeiro Acesso e digite o seu e-mail cadastrado.</p>
      </li>

      <li>
        <p><strong>3.</strong> Você receberá um e-mail para definir a sua senha.</p>
      </li>
    </ul>

    <button type="button" @click="sendEvent">
      Começar
    </button>
  </div>
</template>

<script>
import { isIos } from '@/utils/device';

export default {
  methods: {
    sendEvent() {
      if (isIos()) {
        window.webkit.messageHandlers.checkout.postMessage('');
      } else {
        // eslint-disable-next-line no-undef
        JSBridge.checkout();
      }
    }
  }
};
</script>

<style lang="scss">
ul {
  list-style: none;

  a {
    color: inherit;
    text-decoration: none;
    font-weight: bold;
  }
}

button {
  background-color: var(--color-white);
  color: var(--color-positive-normal);

  border: 1px solid !important;
  border-radius: 8px;

  padding: 16px 40px !important;

  transition: all 0.2s ease-out;

  &:hover {
    background-color: var(--color-positive-normal);
    color: var(--color-white);
  }
}
</style>
